import request from '@/utils/request'
import qs from 'qs'

export function getEmailCode(query) {
    return request({
        url: '/store/api.email/send',
        method: 'post',
        data: qs.stringify(query),
    })
}
export function register(val) {
    // let postData = qs.stringify({ val })
    // console.log(postData)
    return request({
        url: '/store/api.account/register',
        method: 'post',
        data: qs.stringify(val),
    })
}
export function login(val) {
    return request({
        url: '/store/api.account/login',
        method: 'post',
        data: qs.stringify(val),
    })
}
export function getTerms(val) {
    return request({
        url: '/store/api/Account/protocol',
        method: 'get',
        params: val,
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js